export default "__VITE_ASSET__5fd02f22__"